export const ExportFileNames = {
  BENCHMARK_SKILLS: "EYWP_Benchmark_Skills.xlsx",
  BENCHMARK_MICROSKILLS: "EYWP_Benchmark_MicroSkills.xlsx",
  BENCHMARK_JFA: "EYWP_Benchmark_JFA.xlsx",
  PRIMARY_TEXT: "EYWP_Primary_Text.xlsx",
  SECONDARY_TEXT: "EYWP_Secondary_Text.xlsx",
  NEGATIVE_TEXT: "EYWP_Negative_Text.xlsx",
};
